"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCoreXirrProps = exports.RenderXirr = exports.Xirr = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var CoreXirr_1 = require("./CoreXirr");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var WrappedXirr = sdk_ui_1.withContexts(RenderXirr);
/**
 * Xirr computes the [Internal Rate of Return](https://en.wikipedia.org/wiki/Internal_rate_of_return) from the given measure and date dimension.
 * The "X" in the name means that the returns do not have to happen periodically (as in the standard IRR), but they can [happen at any day](https://en.wikipedia.org/wiki/Internal_rate_of_return#Exact_dates_of_cash_flows).
 * You must specify both the measure and date dimension.
 *
 * @remarks For date parsing, we currently use the browser's Date constructor. There might be some differences
 * between how browsers implement this, so for best results use the Day granularity if possible.
 *
 * @beta
 */
exports.Xirr = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measure, props.attribute, props.filters], props.placeholdersResolutionContext), measure = _a[0], attribute = _a[1], filters = _a[2];
    return react_1.default.createElement(WrappedXirr, tslib_1.__assign({}, props, { measure: measure, attribute: attribute, filters: filters }));
};
function RenderXirr(props) {
    return react_1.default.createElement(CoreXirr_1.CoreXirr, tslib_1.__assign({}, toCoreXirrProps(props)));
}
exports.RenderXirr = RenderXirr;
function toCoreXirrProps(props) {
    var buckets = [
        sdk_model_1.newBucket(sdk_ui_1.BucketNames.MEASURES, props.measure),
        sdk_model_1.newBucket(sdk_ui_1.BucketNames.ATTRIBUTE, props.attribute),
    ];
    var newProps = omit_1.default(props, [
        "measure",
        "attribute",
        "filters",
        "backend",
    ]);
    return tslib_1.__assign(tslib_1.__assign({}, newProps), { execution: createExecution(buckets, props), exportTitle: props.exportTitle || "Xirr" });
}
exports.toCoreXirrProps = toCoreXirrProps;
function createExecution(buckets, props) {
    var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
    return backend
        .withTelemetry("Xirr", props)
        .workspace(workspace)
        .execution()
        .forBuckets(buckets, props.filters)
        .withDimensions(sdk_model_1.newDimension(tslib_1.__spreadArrays([
        "measureGroup"
    ], sdk_model_1.bucketsAttributes(buckets).map(function (attribute) { return sdk_model_1.attributeLocalId(attribute); }))))
        .withExecConfig(execConfig);
}
//# sourceMappingURL=Xirr.js.map